import { render, staticRenderFns } from "./Preguntes.vue?vue&type=template&id=6ca5a2ac&"
import script from "./Preguntes.vue?vue&type=script&lang=js&"
export * from "./Preguntes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports